import ApiBase from '@model/api-base';
import di from 'dependency-injection'

/**
 * EdilentWorkerApi
 *
 * @package     edilent-worker
 * @author      Kenichi Kashiwagi <pod@cro-co.co.jp>
 */
class EdilentWorkerApi extends ApiBase {
  constructor(firstPath) {
    super();
    this.firstPath = firstPath;
  }

  request(name, action, data={}, options={}) {
    return this.apiPost(`/${this.firstPath}/${name}/api/v1/${action}`, data, options);
  }
  event(name, action, data) {
    this.trigger(`${name}:${action}`, data);
  }
}
export default EdilentWorkerApi;
